import { useState, useRef } from "react";

import { Loading } from "../loading";

import { Upload, Trash } from "phosphor-react";

interface UploadButtonProps {
  image: string | null;
  onImageSelected: (image: string | null) => void;
}

export function UploadButton({ image, onImageSelected }: UploadButtonProps) {
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alert("Por favor, selecione apenas arquivos de imagem.");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      alert("A imagem deve ter no máximo 5MB.");
      return;
    }

    setIsUploading(true);

    const reader = new FileReader();
    reader.onload = (e) => {
      const result = e.target?.result as string;
      onImageSelected(result);
      setIsUploading(false);
    };
    reader.onerror = () => {
      alert("Erro ao carregar a imagem.");
      setIsUploading(false);
    };
    reader.readAsDataURL(file);
  };

  const handleClick = () => {
    if (image) {
      onImageSelected(null);
    } else {
      fileInputRef.current?.click();
    }
  };

  if (image) {
    return (
      <button
        type="button"
        title="Remover imagem"
        aria-label="Remover imagem"
        onClick={handleClick}
        className="p-1 w-10 h-10 rounded-md border-transparent flex justify-end items-end text-zinc-400 hover:text-zinc-100 transition-colors duration-200 ease-in-out"
        style={{ backgroundImage: `url(${image})` }}
      >
        <Trash weight="fill" />
      </button>
    );
  }

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileSelect}
        className="hidden"
      />
      <button
        type="button"
        title="Enviar imagem do PC"
        aria-label="Enviar imagem do PC"
        onClick={handleClick}
        className="p-2 bg-zinc-800 rounded-md border-transparent hover:bg-zinc-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-zinc-900 focus:ring-brand-500 transition-colors duration-200 ease-in-out"
      >
        {isUploading ? (
          <Loading />
        ) : (
          <Upload weight="bold" className="w-6 h-6" />
        )}
      </button>
    </>
  );
}
